import { Component, OnInit } from '@angular/core';
import { I18nService } from '@core/services/i18n/i18n.service';
import { SeoService } from '@core/services/seo';
import { ThemeService } from '@core/services/theme';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '@app/components/ui/layout/layout.component';
@Component({
  standalone: true,
  selector: 'app-root',

  imports: [CommonModule, LayoutComponent, RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  constructor(private seoService: SeoService, private themeService: ThemeService, private i18nService: I18nService) {}

  ngOnInit(): void {
    this.runGlobalServices();
  }

  private runGlobalServices(): void {
    this.seoService.init();
    this.themeService.init();
    this.i18nService.init();
  }
}
